<template>
  <div class="layout">
    <!-- 顶部导航 -->
    <Header
      :style="{
        background: '#fff',
        boxShadow: '0 2px 3px 2px rgba(0,0,0,.1)',
        padding: 0,
        height: '60px',
        lineHeight: '60px',
      }"
    >
      <Menu
        ref="header_menu"
        mode="horizontal"
        theme="dark"
        :active-name="headerActive"
        @on-select="headerChangeMenu"
        class="headerSetting"
      >
        <div class="layout-logo">
          <img :src="logoUrl" alt="月子会所" class="logoSetting" />
        </div>
        <div class="layout-nav">
          <MenuItem name="erp">
            <Icon type="md-arrow-dropleft-circle" />
            返回ERP
          </MenuItem>
          <MenuItem
            v-for="item in menuList"
            :name="item.show_name"
            :key="item.id"
          >
            <Icon :type="item.icon" />
            {{ item.show_name }}
          </MenuItem>
          <div class="userName">
            <Icon type="ios-contact" size="16" />
            {{ agent_info.store_name }} | {{ agent_info.position_name }} |
            {{ agent_info.user_name }}
          </div>
        </div>
      </Menu>
    </Header>

    <Layout :style="{ marginLeft: SiderMarginLeft, position: 'relative' }">
      <!-- 左侧菜单 -->
      <Sider class="SiderChange" v-show="MenuShow" :width="SiderWidth">
        <Menu
          ref="side_menu"
          :active-name="active"
          :open-names="openNames"
          theme="dark"
          width="auto"
          accordion
          @on-select="leftMenuchange"
        >
          <Submenu
            v-for="item in leftMenuList"
            :name="item.id + ''"
            :key="item.id"
          >
            <template slot="title">
              <Icon :type="item.icon"></Icon>
              {{ item.show_name }}
            </template>
            <MenuItem
              v-for="child in item.child_permissions"
              :name="child.id + ''"
              :key="child.id"
            >
              {{ child.show_name }}
            </MenuItem>
          </Submenu>
        </Menu>
      </Sider>

      <!-- 折叠按钮 -->
      <div class="backBtn" @click="bindtagBack">
        <Icon :type="bintagBackIcon" size="16" color="#ffffff" />
      </div>

      <!-- 右侧内容 -->
      <Content :style="{ padding: '0 16px 16px' }">
        <Breadcrumb :style="{ margin: '16px 0' }">
          <BreadcrumbItem
            v-for="(item, index) in set_VBreadcrumb_arr"
            :key="index"
            >{{ item }}</BreadcrumbItem
          >
        </Breadcrumb>
        <Card class="componentsContent">
          <router-view />
        </Card>
      </Content>
    </Layout>
  </div>
</template>

<script>
/* ========== 工具：过滤菜单 ========== */
function filterMenu(list) {
  const isAdmin = window.agent_info.user_name.includes('管理员'); // 按需改判断规则
  const HIDE_SET = ['工作台','新连锁客户', '连锁客户','门店客户','我的客户','会员管理','延误跟进记录','到店结果统计'];     
  return list
    .filter(item => {
      // 顶部菜单：非管理员去掉“系统设置”
      if (!isAdmin && item.show_name === '系统设置') return false;
      return true;
    })
    .map(item => ({
      ...item,
      child_permissions: (item.child_permissions || []).map(group => ({
        ...group,
        child_permissions: (group.child_permissions || []).filter(
          child => !(HIDE_SET.includes(child.show_name) && !isAdmin)
        )
      })).filter(group => group.child_permissions.length)
    }));
}

export default {
  name: 'App',
  data() {
    return {
      SiderMarginLeft: '160px',
      SiderWidth: 160,
      MenuShow: true,
      bintagBackIcon: 'md-arrow-dropleft',
      logoUrl: require('../src/assets/logo2.png'),
      menuList: filterMenu(window.menuList), // 已过滤
      headerActive: '首页(客户管理)',
      set_VBreadcrumb_arr: [],
      leftMenuList: [],
      active: '84',
      openNames: ['1'],
      agent_info: window.agent_info,
    };
  },
  mounted() {
    this.headerChangeMenu(this.headerActive, 'login');
  },
  methods: {
    bindtagBack() {
      this.MenuShow = !this.MenuShow;
      this.SiderMarginLeft = this.MenuShow ? '160px' : '0px';
      this.bintagBackIcon = this.MenuShow ? 'md-arrow-dropleft' : 'md-arrow-dropright';
    },

    headerChangeMenu(id, login) {
      if (id === 'erp') {
        window.location.href = api.erpUrl;
        return;
      }
      for (const item of this.menuList) {
        if (id === item.show_name) {
          // 过滤后的左侧菜单
          this.leftMenuList = filterMenu([item])[0].child_permissions;
          const firstGroup = this.leftMenuList[0];
          const firstPage = firstGroup.child_permissions[0];
          this.$router.push({ path: firstPage.path });
          this.active = firstPage.id + '';
          this.openNames = [firstGroup.id + ''];
          this.$nextTick(() => {
            this.$refs.side_menu.updateOpened();
            this.$refs.side_menu.updateActiveName();
            this.jumpByQuery(login);
          });
          this.set_VBreadcrumb_arr = [
            item.show_name,
            firstGroup.show_name,
            firstPage.show_name,
          ];
          break;
        }
      }
    },

    leftMenuchange(id, login, page) {
      this.active = id;
      for (const group of this.leftMenuList) {
        for (const child of group.child_permissions) {
          if (id === child.id + '') {
            this.$router.push({ path: page === 'addMember' ? 'addMember' : child.path });
            this.set_VBreadcrumb_arr.splice(1, 2, group.show_name, child.show_name);
            return;
          }
        }
      }
    },

    jumpByQuery(login) {
      if (!login) return;
      const jump = util.getQueryVariable('jump');
      if (!jump) return;

      for (const group of this.leftMenuList) {
        for (const child of group.child_permissions) {
          const path = child.path.replace('/', '');
          if (
            jump === path ||
            (jump === 'addMember' && path === 'customerManagementNew')
          ) {
            this.leftMenuchange(child.id + '', login, jump === 'addMember' ? 'addMember' : '');
            return;
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.layout {
  background: #f5f7f9;
  position: relative;
  overflow: hidden;
}
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.componentsContent {
  height: calc(100vh - 131px);
  overflow: auto;
}
.headerSetting {
  display: flex;
  justify-content: space-between;
}
.logoSetting {
  width: 160px;
  height: 40px;
  margin-top: 10px;
  margin-left: 20px;
}
.layout-nav {
  display: flex;
  justify-content: flex-end;
}
.userName {
  color: #dedede;
  margin-left: 100px;
  margin-right: 20px;
  font-size: 12px;
}
.SiderChange {
  position: fixed;
  height: 100vh;
  left: 0;
}
.backBtn {
  width: 16px;
  height: 40px;
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  top: 48vh;
  cursor: pointer;
  background-color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/App.vue